module.exports = __webpack_public_path__ + "static/img/gouyao@3x.ae2ff72.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/icons/gouyao@3x.jpg
// module id = UT3i
// module chunks = 1